module.exports = __webpack_public_path__ + "static/media/style-quiz.a093e583.png";